<template>
  <div :style="divStyle">
    <el-row>
      <el-col :span="6" v-for="(item, index) in menuTreeList" :key="index">
          <el-card style="margin: 5px;">
            <div slot="header" class="clearfix">
              <el-divider direction="vertical"></el-divider>
              <span>{{ item.meta.title[$i18n.locale] }}</span>
            </div>
            <div>
              <el-tree :data="[item]" :props="defaultProps" node-key="name" :default-expand-all="true" key="name" :ref="'tree' + index"
                :class="'treeClass' + index" @node-click="handleNodeClick" :style="treeStyle" :render-content="renderContent"></el-tree>
            </div>
          </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'homePage',
  computed: {
    treeStyle() {
      return {
        'height': this.screenHeight - 769 + 'px',
        'overflow': 'auto',
      }
    },
    divStyle() {
      return {
        'height': this.screenHeight - 151 + 'px',
        'overflow-y': 'auto',
      }
    },
    // menuTreeList() {
    //   return this.$store.state.menuRouter;
    // }
  },
  watch: {
    menuTreeList(value) {
      if(value && value.length > 0) {
        this.formatMenuTree()
      }
    },
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: (data, node) => {
          return data.meta.title[this.$i18n.locale]
        },
      },
      menuTreeList: [],
      screenHeight: '0',
    };
  },
  methods:{
    handleNodeClick(data) {
      const _this = this;
      _this.$nextTick(function () {
        _this.$forceUpdate()
        //自定义tree树的节点
        //先获取节点
        let array = document.querySelectorAll('.is-current');
        if (array && array.length > 0) {
          for (let i = 0; i < array.length; i++) {
            const element = array[i].getElementsByClassName('el-tree-node__content');
            $('.el-tree-node__content').removeClass("s-bg2");
            $('.el-tree-node__content').removeClass("s-c");
            for (let j = 0; j < element.length; j++) {
              if (data.hasOwnProperty('children')) {
                if (element[j].className.indexOf('s-bg2') === -1) {
                  element[0].className += " s-bg2 s-c";
                }
              } else {
                if (element[j].className.indexOf('s-bg2') === -1) {
                  element[j].className += " s-bg2 s-c";
                }
              }
            }
          }
        }
        if(!data.children || data.children.length == 0) {
          if(data.memo1 == '1') {
            window.open(data.path, "_blank");
          } else if(data.memo1 == '2') {
            _this.$router.push({
              name: data.name,
              params: { mbid: data.memo2 }
            }).catch(err => {err});
          } else {
            // 菜单路由跳转
            _this.$router.push({path: data.path}).catch(err => {err});
          }
        }
      });
    },
    formatMenuTree() {
      this.menuTreeList = this.$store.state.menuRouter;
      if(this.menuTreeList && this.menuTreeList.length > 0) {
        this.getTreeData(this.menuTreeList)
        for(let tmp = 0; tmp < this.menuTreeList.length; tmp++) {
          if(this.menuTreeList[tmp].path == '/') {
            this.menuTreeList.splice(tmp, 1);
          }
        }
      }
    },
    getTreeData(data) {
      for(let i = 0; i < data.length; i++) {
        if(data[i].hidden) {
          data.splice(i, 1);
          // 解决因splice删掉的数组元素改变了数组长度，导致数组不能完全遍历
          i = i - 1;
        } else {
          let tmp = data[i].children
          if(tmp.length == 0) {
            // children若为空数组，则将children设为undefined
            tmp = undefined;
          } else {
            // children若不为空数组，则继续 递归调用 本方法
            this.getTreeData(tmp);
          }
        }
      }
    },
    renderContent(h, { node, data, store }) {
      if(data.meta.icon.indexOf('el-') > -1) {
        return (
          <span class="custom-tree-node">
            <i class={ data.meta.icon }></i>
            <span style="margin-left: 5px; font-size: 14px; focus: red">{ node.label }</span>
          </span>
        );
      } else {
        return (
          <span class="custom-tree-node">
            <svg-icon icon-class={ data.meta.icon } />
            <span style="margin-left: 5px; font-size: 14px; focus: red">{ node.label }</span>
          </span>
        );
      }
    }
  },
  created() {
    this.menuTreeList = []
    if(Object.keys(this.$store.state.menuRouter).length == 0) {
      this.$store.commit('setMenuRouter', JSON.parse(this.$session.getItem('menuRouter')));
    };
  },
  mounted() {
    this.menuTreeList = this.$store.state.menuRouter;
    this.formatMenuTree();
    this.$root.$on("menuRouter", data => {    // 布局变换
      this.menuTreeList = data;
      this.formatMenuTree();
    });
    // 监听浏览器的宽和高
    this.screenHeight = document.body.clientHeight
    window.addEventListener('resize', () => this.screenHeight = window.innerHeight, false)
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 10px 20px;
}
::v-deep .el-tree-node.is-expanded>.el-tree-node__children {
  display: inline;
}
::v-deep .el-tree-node__expand-icon {
  display: none;
}
::v-deep .el-divider--vertical {
  width: 5px;
  height: 1.5em;
  margin: 0 10px 0 0;
}
::v-deep .svg-icon {
  width: 1em;
  height: 1em;
}
.el-divider {
  background-color: #409EFF;
}
</style>

<style lang="scss">
.s-c {
  color: #409eff;
  font-weight: bolder;
}
</style>